import type { AnyApi } from "./api.ts";
import type { FetchRequest, FetchResponse } from "./BaseApiClient.ts";
import { BaseApiClient } from "./BaseApiClient.ts";

export class FetchApiClient<Api extends AnyApi> extends BaseApiClient<Api> {
  protected async fetch(request: FetchRequest): Promise<FetchResponse> {
    return fetch(request.url, {
      body: request.body,
      headers: request.headers,
      method: request.method,
    });
  }
}
